import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {getAccommodationOptions} from '../../reducers'
import Utils from '../../Utils'
import './accommodation.css'

import BookingDotComLink from '../BookingDotComLink/BookingDotComLink'

const renderAccommodationOption = (accommodation, index, arr) => {
  return (
    <div key={accommodation.name} className="accommodation-option">
      <h3>{accommodation.name}</h3>
      <p className="address">{accommodation.address}</p>
      <p className="description">
        <i>{accommodation.description}</i>
      </p>
      {accommodation.rooms && (
        <p className="number-of-rooms">
          Number of Rooms: {accommodation.rooms}
        </p>
      )}
      {accommodation.distanceFromVenue && (
        <p>Distance from Venue: {accommodation.distanceFromVenue}</p>
      )}
      <p>
        <a href={'tel:' + Utils.formatPhoneNumber(accommodation.phone)}>
          {accommodation.phone}
        </a>
      </p>
      <p>
        <a href={'mailto:' + accommodation.email}>{accommodation.email}</a>
      </p>
      {accommodation.website && (
        <p>
          <a href={accommodation.website} target="_blank">
            Website
          </a>
        </p>
      )}
      {accommodation.bookingDotCom && (
        <BookingDotComLink
          url={accommodation.bookingDotCom.url}
          text={'£' + accommodation.bookingDotCom.priceFrom}
          subtext="p/night"
        />
      )}
      {index !== arr.length - 1 && <hr />}
      {index === arr.length - 1 && <hr className="last" />}
    </div>
  )
}

export class AccommodationOptionsContainer extends Component {
  render() {
    return (
      <div>
        {this.props.accommodationOptions.map(renderAccommodationOption)}
      </div>
    )
  }
}
AccommodationOptionsContainer.propTypes = {
  accommodationOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
}

const mapStateToProps = state => ({
  accommodationOptions: getAccommodationOptions(state),
})

const mapDispatchToProps = dispatch => ({})

const AccommodationOptions = connect(mapStateToProps, mapDispatchToProps)(
  AccommodationOptionsContainer
)

export default AccommodationOptions



// WEBPACK FOOTER //
// ./src/components/Accommodation/AccommodationOptions.js